import React, { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { Button } from "../components/kit";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const nextPath = (params.get("next") || "").startsWith("/") ? params.get("next") : "";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      navigate(nextPath || (u.role === "admin" ? "/admin" : (u.role === "coach" ? "/coach" : (u.onboarding_complete ? "/dashboard" : "/onboarding"))));
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Welcome back" subtitle="Sign in to see your Business Health Score." testId="login-page">
      <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: "var(--space-4)" }}>
        {error && <div data-testid="login-error" style={errStyle}>{error}</div>}
        <label style={lbl}>Email
          <input data-testid="login-email" className="buktu-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@business.com" required />
        </label>
        <label style={lbl}>Password
          <input data-testid="login-password" className="buktu-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
        </label>
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: -8 }}>
          <Link to="/forgot-password" data-testid="login-forgot-link" style={{ font: "var(--type-body-sm)", fontSize: 13, color: "var(--text-link)" }}>Forgot password?</Link>
        </div>
        <Button type="submit" full size="lg" data-testid="login-submit" disabled={loading}>
          {loading ? "Signing in…" : "Sign in"}
        </Button>
        <p style={{ font: "var(--type-body-sm)", color: "var(--text-muted)", textAlign: "center", marginTop: "var(--space-2)" }}>
          New to Buktu? <Link to="/register" data-testid="login-register-link" style={{ color: "var(--text-link)" }}>Get started</Link>
        </p>
      </form>
    </AuthLayout>
  );
}

const lbl = { display: "flex", flexDirection: "column", gap: "var(--space-2)", font: "var(--type-label)", color: "var(--text-strong)" };
const errStyle = { padding: "var(--space-3) var(--space-4)", borderRadius: "var(--radius-md)", background: "var(--status-risk-soft)", color: "#8a2a1a", font: "var(--type-body-sm)", fontSize: 13 };
